/* AGC Card Quick-Add Controller — Director-approved 2026-04-30
   Wires the (previously decorative) variant pickers on collection product cards.
   Click a swatch/pill -> updates the hidden 'id' input on the card's <form> with
   the matching variant id, toggles the ATC button enabled/disabled state, and
   maintains a single 'selected' visual state per option group.
   Idempotent: re-import safe; only one delegated listener attaches per page. */
(function(){
  if (window.__agcCardQuickAddWired) return;
  window.__agcCardQuickAddWired = true;

  function getCard(node){
    // closest() returns the FIRST matching ancestor regardless of selector order,
    // so we must check OUTER wrappers (product-block) before falling back to
    // INNER wrappers (product-form). Variant pickers live in product-block but
    // are siblings of product-form. Walk explicitly to prioritise.
    return node.closest('product-block')
        || node.closest('.product-block')
        || node.closest('.product-thumb')
        || node.closest('product-form')
        || node.closest('.product-form');
  }
  function getCardForm(card){
    if (!card) return null;
    return card.querySelector('form.agc-card-form, form.js-product-card-form');
  }
  function getVariants(card){
    if (!card) return null;
    var s = card.querySelector('.js-card-variants');
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch(e) { return null; }
  }
  function getSelectedOptions(card){
    var groups = card.querySelectorAll('.product-block-options');
    var names = [];
    var values = [];
    groups.forEach(function(g){
      names.push(g.dataset.optionName || '');
      var sel = g.querySelector('.product-block-options__item--selected')
             || g.querySelector('.product-block-options__item');
      values.push(sel ? (sel.dataset.optionItem || '') : '');
    });
    return { names: names, values: values };
  }
  function findVariant(variants, targetValues){
    if (!variants) return null;
    return variants.find(function(v){
      if (!v.options || v.options.length !== targetValues.length) return false;
      for (var i=0;i<v.options.length;i++){
        if (v.options[i] !== targetValues[i]) return false;
      }
      return true;
    });
  }
  function updateCardFromSelection(card){
    var form = getCardForm(card);
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput) return;
    var sel = getSelectedOptions(card);
    var variants = getVariants(card);
    var match = findVariant(variants, sel.values);
    if (!match) return;
    idInput.value = match.id;
    var btn = form.querySelector('button[name="add"], .add-to-cart, .btn-for-cart');
    if (btn){
      if (match.available){
        btn.disabled = false;
        btn.classList.remove('is-sold-out');
        if (btn.dataset.addLabel) btn.textContent = btn.dataset.addLabel;
      } else {
        btn.disabled = true;
        btn.classList.add('is-sold-out');
        if (btn.dataset.soldOutLabel) btn.textContent = btn.dataset.soldOutLabel;
      }
    }
  }

  function initCards(){
    document.querySelectorAll('form.agc-card-form, form.js-product-card-form').forEach(function(form){
      var card = getCard(form) || form.parentElement;
      if (!card) return;
      card.querySelectorAll('.product-block-options').forEach(function(group){
        if (group.querySelector('.product-block-options__item--selected')) return;
        var firstAvail = group.querySelector('.product-block-options__item:not(.product-block-options__item--unavailable)')
                      || group.querySelector('.product-block-options__item');
        if (firstAvail) firstAvail.classList.add('product-block-options__item--selected');
      });
      updateCardFromSelection(card);
    });
  }

  document.addEventListener('click', function(e){
    var item = e.target.closest('.product-block-options__item');
    if (!item) return;
    var card = getCard(item);
    if (!card) return;
    if (!getCardForm(card)) return;
    e.preventDefault();
    var group = item.closest('.product-block-options');
    if (group){
      group.querySelectorAll('.product-block-options__item--selected')
        .forEach(function(s){ s.classList.remove('product-block-options__item--selected'); });
      item.classList.add('product-block-options__item--selected');
    }
    updateCardFromSelection(card);
  }, true);

  // Initial pass + retry passes for custom-element upgrade timing
  function runInit(){
    initCards();
  }
  if (document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', runInit);
  } else {
    runInit();
  }
  // Custom elements (e.g., <product-block>) can upgrade after our deferred script runs.
  // Re-run init when the custom element becomes defined, and again after a short tick.
  if (window.customElements){
    if (window.customElements.whenDefined){
      window.customElements.whenDefined('product-block').then(function(){
        setTimeout(runInit, 50);
      }).catch(function(){});
    }
  }
  setTimeout(runInit, 250);
  setTimeout(runInit, 1000);

  // Watch for late-injected cards (e.g., infinite scroll, AJAX filtering)
  if (window.MutationObserver){
    var mo = new MutationObserver(function(muts){
      var hasNewCard = muts.some(function(m){
        return Array.from(m.addedNodes || []).some(function(n){
          return n.nodeType === 1 && (n.matches?.('form.agc-card-form, .product-block') || n.querySelector?.('form.agc-card-form'));
        });
      });
      if (hasNewCard) runInit();
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }
})();
